import * as types from '../mutation-types'
import api from '@/http/api'
import { getPromiseAction ,getPromiseActionNoMutations} from '@/utils/promiseUtils'

export default {
  namespaced: true,
  state() {
    return {
      themeColor:{
        header_background_color  : '',
        header_times_background_color:'',
        header_text_color        : '',
        menu_background_color    : '',
        menu_text_color          : '',
        copy_background_color    : '',
        content_background_color : '',
        content_table_color      : '',
        content_border_color     : '',
        content_text_color       : '',
        btn_danger_text          : '',
        btn_danger_background    : '',
        btn_warning_text         : '',
        btn_warning_background   : '',
        btn_info_text            : '',
        btn_info_background      : '',
        btn_success_text         : '',
        btn_success_background   : '',
        btn_primary_text         : '',
        btn_primary_background   : '',
        btn_secondary_text       : '',
        btn_secondary_background : '',
        btn_dark_text            : '',
        btn_dark_background      : ''
      },
      title: '',
      menuShow: true,
      stationId: localStorage.getItem('station-id'),
      iconType: false,
      tableTabs:JSON.parse( localStorage.getItem('tableTabs') ) || [ ],
      tabsShow: localStorage.getItem('tabsShow')  || 'hide',
      breadcrumbArr:[],
	    baseQueue: {
        list: [],
        running: false,
        interval: null
	    },
	    appData: {
        product: [],
        country: [],
        currency: []
	    },
    }
  },
  getters: {
    getQueueInterval(state) {
      return state.baseQueue.interval;
    }
  },
  mutations: {
    setBreadcrumbArr(state,data){
      state.breadcrumbArr = data ;
    },
    pushBreadcrumbArr(state,data){
      let arr = state.breadcrumbArr;
      arr.push(data)
      state.breadcrumbArr = arr ;
    },
    delBreadcrumbArr(state,data){
      let arr = state.breadcrumbArr;
      if(data+1 === arr.length) return ;
      let newArr = arr.slice(0,data+1);
      state.breadcrumbArr = newArr ;
    },
    setTitle(state, title) {
      state.title = title;
    },
    setMenuShow(state, bool) {
      state.menuShow = bool;
    },
    setStationId(state, id) {
      state.stationId = id;
      localStorage.setItem("station-id", id);
    },
    setTabsShow(state,bool){
      state.tabsShow = bool ;
    },
    setThemeColor(state,obj){
      state.themeColor = obj ;
    },
    setTableTabs(state,item){
      let tool = true ;
      let {length} = state.tableTabs ;
      if(length){
        state.tableTabs.forEach(element=>{
          element.tableIndex = false ;
          if( item && item.path===element.path){
            tool = false ;
            element.tableIndex = true ;
          }

        })
      }

      tool && item && state.tableTabs.push(item) ;
      length>7 && state.tableTabs.shift() ;

    },
    deleteItemTabs(state,index) {
      let arr = state.tableTabs.map(item=>{
        return item ;
      })
      arr.splice(index,1)
      let {length} = arr ;
      if(length){
        if(index===0){
          arr[0].tableIndex = true ;
        }else{
          let i = parseInt(index-1);
          arr[i].tableIndex = true ;
        }
      }

      state.tableTabs = arr ;
    },
    setIconType(state,data) {
      state.iconType = data ;
    },
    setQueueInterval(state, data) {
      state.baseQueue.interval = data
    },
    [types.BASE_QUEUE](state, body) {
      if (body.data) {
        state.baseQueue.list = body.data
        state.baseQueue.running = false
        body.data.forEach(v => {
          if (v.status === 'executing') {
            state.baseQueue.running = true
          }
        })
	    }
    },
    [types.BASE_APP_DATA](state, body) {
      if (body.data) {
        state.appData.product = body.data.product || []
        state.appData.country = body.data.country || []
        state.appData.currency = body.data.currency || []
      }
	  }
  },
  actions: {
    loadGetBaseQueue({commit},payload){
      return getPromiseAction(api.getBaseQueue(payload), commit, types.BASE_QUEUE)
    },
    savePostBaseQueueUpdate({commit},payload){
      return getPromiseAction(api.postBaseQueueUpdate(payload), commit, types.BASE_QUEUE)
    },
	  loadGetBaseQueueDownload({commit},payload) {
      return getPromiseActionNoMutations(api.getBaseQueueDownload(payload))
	  },
	  loadGetBaseApplicationData({commit},payload) {
	    return getPromiseAction(api.getBaseAppData(payload), commit, types.BASE_APP_DATA)
	  }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/home/index.js